/**
 * Отправка сбоев, случившихся на стороне человека.
 *
 * Половина работы приложения проходит мимо нашего сервера: транзакция идёт
 * из браузера в кошелёк через мост TON Connect, индекс гифта читается прямо
 * у TON API. Когда ломается там, человек видит ошибку, а в наших логах —
 * ничего, и на вопрос «что у него случилось» ответить нечем.
 *
 * Отправка молчаливая и необязательная: сбой уже произошёл, и второй сбой
 * поверх первого человеку не нужен.
 */

import { reportClientError } from './api.ts';
import { tonConnectKind } from './errors.ts';
import { getInitData } from './telegram.ts';

/** Отказ человека в кошельке — не сбой, и засорять им журнал незачем. */
const NOT_A_FAILURE = /reject|cancell?ed|user declined|was not sent/i;

export function reportFailure(where: string, e: unknown, extra = ''): void {
  const message = e instanceof Error ? e.message : String(e ?? '');
  if (message === '' || NOT_A_FAILURE.test(message)) return;

  // Имя класса ошибки TON Connect минифицируется в сборке, и в журнал
  // попадало `[TON_CONNECT_SDK_ERROR] ji` — столько же смысла, сколько
  // человек видел на экране. Добавляем то, что минификация не трогает.
  const kind = tonConnectKind(e) ?? (e instanceof Error ? e.constructor.name : typeof e);
  // Код от кошелька. Мост присылает его числом рядом с текстом, а SDK
  // раскладывает по классам ошибок — но только известные ему. Неизвестный
  // становится UnknownError, и тогда число остаётся единственным, что
  // кошелёк вообще сказал о причине.
  const raw = e as { code?: unknown };
  const code = typeof raw.code === 'number' || typeof raw.code === 'string' ? ` code:${String(raw.code)}` : '';
  const stack = e instanceof Error && typeof e.stack === 'string' ? e.stack.split('\n')[1] ?? '' : '';
  // Что именно мы отправляли: без этого отказ кошелька без кода и текста
  // не разобрать — непонятно даже, был ли запрос осмысленным.
  const detail = `${message} · ${kind}${code}${extra === '' ? '' : ' · ' + extra}${stack === '' ? '' : ' · ' + stack.trim()}`;

  const initData = getInitData();
  if (initData === '') return;

  void reportClientError({ initData, where, message: detail }).catch(() => {
    // Некуда: отчёт о сбое, не дошедший из-за сбоя, — это всё тот же сбой.
  });
}
